module.exports = __webpack_public_path__ + "76079509.svg";